import { j as e } from "../../jsx-runtime.BREq8dyb.js";
import { styled as n, DialogTitle as a, useThemeProps as m } from "@mui/joy";
import { memo as p } from "react";
import d from "../DqSidePanelClose/DqSidePanelClose.js";
import P from "../DqSidePanelTitleToolbar/DqSidePanelTitleToolbar.js";
const r = "DqSidePanelTitle", T = n(a, {
  name: r,
  slot: "root"
})(), u = p((t) => {
  const {
    children: s,
    ToolbarProps: l,
    ...i
  } = m({
    name: r,
    props: t
  }), o = {
    buttons: [/* @__PURE__ */ e.jsx(d, {}, "side-panel-close")],
    ...l
  };
  return /* @__PURE__ */ e.jsxs(T, { ...i, children: [
    s,
    Array.isArray(o.buttons) && o.buttons.length > 0 || Array.isArray(o.menuItems) && o.menuItems.length > 0 ? /* @__PURE__ */ e.jsx(P, { ...o }) : null
  ] });
});
u.displayName = "DqSidePanelTitle";
export {
  u as default
};
//# sourceMappingURL=DqSidePanelTitle.js.map
